import {Accordion, Heading, HStack, IconButton, VStack} from "@chakra-ui/react";
import DealForm from "./DealForm";
import {useEffect, useState} from "react";
import {IDeal, NewDealSuggestion} from "../../interfaces/IDeal";
import {useTranslations} from "next-intl";
import {MdAdd} from "react-icons/md";

export function DealListForm<T extends IDeal, D extends NewDealSuggestion>(
    {initialDeals, deals, onChange, onActivated, title}: {initialDeals: T[], deals: D[], onChange: (deals: D[]) => void, onActivated: (active: boolean) => void, title: string}
) {
    const t = useTranslations("addbar")
    const [editingDealIndex, setEditingDealIndex] = useState(-1)

    useEffect(() => {
        if (deals.length <= editingDealIndex) setEditingDealIndex(-1)
    }, [deals, editingDealIndex]);

    useEffect(() => {
        onActivated(editingDealIndex != -1)
    }, [editingDealIndex, onActivated]);

    function addNewDeal() {
        const newDeals = [
            ...deals,
            {description: "", days: {}, conditions: "", original: null} as D
        ]
        onChange(newDeals)
        setEditingDealIndex(newDeals.length - 1)
    }
    return (
        <>
            <VStack>
                <HStack justify="space-between" w="100%">
                    <Heading size="md">{title}</Heading>
                    <IconButton icon={<MdAdd/>} aria-label={t("add_deal")} variant="secondary" isDisabled={editingDealIndex != -1} onClick={addNewDeal}></IconButton>
                </HStack>
                <Accordion index={editingDealIndex} maxW="100%">

                    { deals.map((value, index) =>
                        (
                            <DealForm<T, D> key={value.description + index.toString()} deal={value} initialDeal={initialDeals[index]} updateDeal={updatedDeal => {
                                const updated = deals.map((originalDeal, index1) => index1 == index ? updatedDeal : originalDeal)
                                onChange(updated)
                            }} deleteDeal={() =>
                                onChange(deals.filter((value1, index1) => index1 != index))
                            } onDoneEditing={() =>
                                setEditingDealIndex(-1)
                            } onStartEditing={() => {
                                setEditingDealIndex(index)
                            }}
                                            editingThis={editingDealIndex == index} editingOther={editingDealIndex != index && editingDealIndex != -1}></DealForm>
                        )
                    ) }
                </Accordion>
            </VStack>
        </>
    )

}